import { userInfoFrag } from '../../../../utils/type/user.common-type';

export const operationalWorkDetailFrag = `
    id
    workType
    serviceId
    dateFrom
    dateTo
    users {
        ${userInfoFrag}
    }
    files {
        fileId
        name
        path
    }
    offers {
        id
        offerId
        applications
        operations
        procedures
        serviceOffer {
            code
            name
            color
        }
    }
    workData {
        ... on WorkDataOperationalWorkObject {
            name
            description
        }
    }
`;
